// extracted by mini-css-extract-plugin
export default {"container":"SimplifiedNoteByNotePlayer_container__VJb2S","stepThrough":"SimplifiedNoteByNotePlayer_stepThrough__i3qb2"};